import React from 'react'

import { CalendarIcon, ClockIcon } from '@application/Interfaces/Icons'
import { useTranslation } from '@src/Application/Interfaces/Hooks/useTranslation'
import { CategoryType, ThemeModeType } from '@src/Application/Types/ComponentTypes'

import { Image, Tag, Wrapper } from './MiddleContent.styled'

export type MiddleContentType = {
    readingTime: number
    updatedAt?: string
    category?: CategoryType
    mode: ThemeModeType
}

export const MiddleContent = (props: MiddleContentType): JSX.Element => {
    const { category, updatedAt, readingTime, mode } = props
    const { t } = useTranslation()

    return (
        <Wrapper $mode={mode}>
            {category && (
                <Tag>
                    {category.image && <Image image={category.image} height={16} width={16} />}
                    {category.title}
                </Tag>
            )}
            {updatedAt && (
                <Tag>
                    <CalendarIcon colorCode={mode === 'Dark' ? 'white' : 'black'} />
                    {t('updatedOn')} {updatedAt}
                </Tag>
            )}
            <Tag>
                <ClockIcon colorCode={mode === 'Dark' ? 'white' : 'black'} />
                {readingTime} {t('minRead')}
            </Tag>
        </Wrapper>
    )
}
